import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core/";
import AppBar from "@material-ui/core/AppBar";
import Snackbar from "@material-ui/core/Snackbar";
import Toolbar from "@material-ui/core/Toolbar";
import { withStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Autocomplete } from "@mui/material";
import useGoogleSheets from 'use-google-sheets';
import logo from "../gonext1.png";
import styles from "../styles";
import Footer from "./Footer";
import Navigation from "./Navigation";

const MainPage = ({ classes }) => {
  const { data } = useGoogleSheets({
    apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    sheetId: process.env.REACT_APP_GOOGLE_SHEETS_ID,
  });

  const finalData = data.length > 1 ? data[0].data.concat(data[1].data, data[2].data, data[3].data, data[4].data) : [];

  const [inputCommand, setInputCommand] = useState({
    inputCommand: " ",
    inputCommandExample: null,
    inputCommandLink: null,
  });

  const [inputCommandType, setInputCommandType] = useState(null);

  const [outputCommand, setOutputCommand] = useState({
    outputCommand: "",
    outputCommandExample: null,
    outputCommandLink: null,
    partialMatch: null,
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleClick = () => {
    setOpenSnackbar(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };
  const refreshPage = () => {
    window.location.reload(true);
  };

  const setCloudType = ({ command }) => {
    if (command.startsWith("g") || command.startsWith("bq")) {
      setInputCommandType("GCP");
    } else if (command.startsWith("a")) {
      setInputCommandType("AWS");
    } else {
      return;
    }
  };
  // Returns row in which input == AWS or GCP
  const filterCommand = (command, cloud_provider) => {
    const features = finalData.filter((feature) => {
      if (cloud_provider === "AWS") {
        return feature.AWS_Command === command;
      } else if (cloud_provider === "GCP") {
        return feature.GCP_Command === command;
      } else {
        return null;
      }
    });
    return features;
  };
  const handleInputCommandChange = (e, finalValue = false) => {

    if (!e.target.value) {
      return;
    }
    var command = e.target.value.trim().toLowerCase();
    command = command.replace(".", "");

    setCloudType({ command });
    if (command.length > 0) {
      // if GCP
      if (inputCommandType === "GCP") {
        const filtered_data = filterCommand(command, "GCP");

        if (filtered_data.length > 0) {
          setInputCommand({
            ...inputCommand,
            inputCommand: command,
            inputCommandExample: filtered_data[0].GCP_Command_Example,
            inputCommandLink: filtered_data[0].GCP_Link,
            commandDescription: filtered_data[0].Command_Description,
          });
          setOutputCommand({
            ...outputCommand,
            outputCommand: filtered_data[0].AWS_Command,
            outputCommandExample: filtered_data[0].AWS_Command_Example,
            outputCommandLink: filtered_data[0].AWS_Link,
            partialMatch: filtered_data[0].Partial_Match === 'Yes',
          });
        } else {
          setInputCommand({
            ...inputCommand,
            inputCommand: command,
            inputCommandExample: null,
            inputCommandLink: null,
            commandDescription: null,
          });
          setOutputCommand({
            ...outputCommand,
            outputCommand: null,
            outputCommandExample: null,
            outputCommandLink: null,
            partialMatch: false,
          });
        }
      }

      // if AWS
      else if (inputCommandType === "AWS") {
        const filtered_data = filterCommand(command, "AWS");
        if (filtered_data.length > 0) {
          setInputCommand({
            ...inputCommand,
            inputCommand: command,
            inputCommandExample: filtered_data[0].AWS_Command_Example,
            inputCommandLink: filtered_data[0].AWS_Link,
            commandDescription: filtered_data[0].Generic_Command,
          });
          setOutputCommand({
            ...outputCommand,
            outputCommand: filtered_data[0].GCP_Command,
            outputCommandExample: filtered_data[0].GCP_Command_Example,
            outputCommandLink: filtered_data[0].GCP_Link,
            partialMatch: filtered_data[0].Partial_Match === 'Yes',
          });
        } else {
          setInputCommand({
            ...inputCommand,
            inputCommand: command,
            inputCommandExample: null,
            inputCommandLink: null,
            commandDescription: null,
          });
          setOutputCommand({
            ...outputCommand,
            outputCommand: null,
            outputCommandExample: null,
            outputCommandLink: null,
            partialMatch: false,
          });
        }
      }
    }
  };

  const copyToClipboard = () => {
    window.navigator.clipboard.writeText(outputCommand.outputCommand);
  };

  return (
    <div className={classes.root}>
      <AppBar position="fixed" color="default" className={classes.appBar}>
        <Toolbar className={classes.toolbar} style={{ marginBottom: "1em" }}>
          <Typography variant="h6" color="inherit" noWrap>
            <div>
              <button
                className={classes.homeButton}
                onClick={refreshPage}
                color="#F9F9F9"
              >
                <img className={classes.logo} src={logo} alt="logo"></img>
                <h4
                  style={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    display: "inline-block",
                    paddingLeft: "10px",
                  }}
                >
                  {" "}
                  Cloud Translate
                </h4>
              </button>
            </div>

            <Typography
              variant="h6"
              style={{ fontStyle: "italic", paddingLeft: ".25em", textWrap: 'pretty' }}
            >
              Translate Between AWS and GCP CLI Commands
            </Typography>
            <Navigation></Navigation>
          </Typography>
        </Toolbar>
      </AppBar>

      <Grid container direction="column" className={classes.mainGrid}>
        <Grid container direction="column">
          {/* First Row */}
          <Grid
            className={classes.firstRow}
            container
            direction="row"
            spacing={2}
          >
            {/* Input Command Grid */}
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              height="100%"
              style={{
                justifyContent: "center",
                alignItems: "center",
                marginRight: "1em",
                height: "100%",
              }}
            >
              <Paper
                centered
                height="100%"
                width="70%"
                style={{ marginLeft: "1em", borderRadius: "1em" }}
              >
                <Autocomplete
                  id="gcp-aws-autocomplete"
                  options={finalData}
                  placeholder="Enter your command"
                  sx={{ width: 300 }}
                  onInputChange={(e) => handleInputCommandChange(e)}
                  getOptionLabel={inputCommandType === 'GCP' ? (option) => option.GCP_Command : (option) => option.AWS_Command}
                  filterOptions={(options, state) => {
                    if (state.inputValue.length > 5) {
                      if (inputCommandType === 'GCP') {
                        return options.filter((item) =>
                          String(item.GCP_Command).toLowerCase().includes(state.inputValue.toLowerCase())
                        );
                      } else {
                        return options.filter((item) =>
                          String(item.AWS_Command).toLowerCase().includes(state.inputValue.toLowerCase())
                        )
                      }

                    }
                    return [];
                  }}
                  renderInput={(params) => (
                    <TextField {...params}
                      centered
                      fullWidth
                      className={classes.inputCommandGrid}
                      placeholder="Enter your command"
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        width: "95%",
                        marginLeft: "1em",
                        fontSize: '1em'

                      }}
                      color="#FFFFFF"
                    />
                  )}
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    width: "95%",
                    marginLeft: ".01em",
                  }}
                  freeSolo
                />
              </Paper>
            </Grid>

            {/* Output Command card */}
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              height="100%"
              color="#90CAF9"
              style={{
                justifyContent: "center",
                alignItems: "center",
                marginRight: "1em",
              }}
            >
              <Paper
                centered
                height="100%"
                className={classes.outputCommandGrid}
                color="#90CAF9"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "1em",
                }}
              >
                <br />
                <br />
                <br />
                {outputCommand.outputCommand ? (
                  <Typography className={classes.title} variant="h5">
                    {outputCommand.outputCommand}
                    <CopyToClipboard
                      text={outputCommand.outputCommand}
                    // onCopy={() => setState({ copied: true })}
                    >
                      <IconButton
                        aria-label="copy"
                        className="margin"
                        onClick={(event) => {
                          copyToClipboard();
                          handleClick(event);
                        }}
                      >
                        <FileCopyOutlinedIcon className="symbols" />
                      </IconButton>
                    </CopyToClipboard>
                  </Typography>
                ) : (
                  <Typography
                    className={classes.translationPlaceholder}
                    variant="h5"
                  >
                    Translation
                  </Typography>
                )}
              </Paper>
            </Grid>
          </Grid>
        </Grid>

        <Grid>
          {/* Second Row */}
          <Grid
            className={classes.secondRow}
            container
            direction="row"
            spacing={2}
          >
            {/* Card One (Input Description) */}
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              height="100%"
              style={{
                justifyContent: "center",
                alignItems: "center",
                marginRight: "1em",
                height: "100%",
              }}
            >
              <Card
                elevation={10}
                style={{
                  height: "100%",
                  marginLeft: "1em",
                  borderRadius: "1em",
                  minHeight: '197px'
                }}
              >
                <CardContent>
                  <Typography
                    className="title"
                    color="textSecondary"
                    gutterBottom
                  >
                    {inputCommandType}
                  </Typography>
                  <Typography className="white" variant="h5" component="h2">
                    {inputCommand.inputCommand}{" "}
                  </Typography>
                  <br></br>
                  <Typography className="white" variant="h6" component="p">
                    {inputCommand.commandDescription} <br />
                  </Typography>

                  <br></br>
                  {inputCommand.inputCommandExample ? (
                    <Typography
                      className="title"
                      color="textSecondary"
                      gutterBottom
                    >
                      Example: {inputCommand.inputCommandExample}{" "}
                    </Typography>
                  ) : null}
                  <br></br>
                </CardContent>
                <CardActions style={{ marginLeft: ".5em" }}>
                  {inputCommand.inputCommandLink ? (
                    <h3>
                      <a
                        href={inputCommand.inputCommandLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "blue" }}
                      >
                        Docs
                      </a>
                    </h3>
                  ) : null}
                </CardActions>
              </Card>
            </Grid>

            {/* Card Two (Output Command) */}
            <Grid
              item
              xs={12}
              sm={6}
              lg={6}
              spacing={20}
              style={{
                justifyContent: "center",
                alignItems: "center",
                marginRight: "1em",
                height: "100%"
              }}
            >
              <Card
                elevation={10}
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "1em",

                  minHeight: '197px'
                }}
              >
                <CardContent>
                  <Typography
                    className="title"
                    color="textSecondary"
                    gutterBottom
                  >
                    {inputCommandType === "GCP"
                      ? "AWS"
                      : inputCommandType === "AWS"
                        ? "GCP"
                        : null}
                  </Typography>
                  {outputCommand.outputCommand === "(No Matching Command)" ? (
                    <Typography
                      variant="h9"
                      component="h2"
                      fontWeight="italic"
                    ></Typography>
                  ) : (
                    <Typography className="white" variant="h5" component="h2">
                      {outputCommand.outputCommand}
                      {outputCommand.partialMatch ? "**" : null}
                    </Typography>
                  )}
                  <br></br>
                  {outputCommand.outputCommand === "(No Matching Command)" ? (
                    <Typography>
                      <br />
                    </Typography>
                  ) : (
                    <Typography className="white" variant="h6" component="p">
                      {inputCommand.commandDescription}
                      <br />
                    </Typography>
                  )}
                  <br></br>
                  {outputCommand.outputCommandExample ? (
                    <Typography color="textSecondary" gutterBottom>
                      Example: {outputCommand.outputCommandExample}{" "}
                    </Typography>
                  ) : null}
                  <br></br>
                </CardContent>
                <CardActions style={{ marginLeft: ".5em" }}>
                  {outputCommand.outputCommandLink ? (
                    <h3>
                      <a
                        href={outputCommand.outputCommandLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "blue" }}
                      >
                        Docs
                      </a>
                    </h3>
                  ) : null}
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="column"
          style={{ alignItems: "flex-end", justifyContent: "flex-end" }}
        >
          {outputCommand.partialMatch ? (
            <Grid
              item
              className="panel"
              style={{ marginRight: "2em", marginTop: "3em" }}
            >
              <Typography>
                ** Refers to a partial match, or a command that is similar but
                not the exact same in its functionality.
              </Typography>
            </Grid>
          ) : null}
        </Grid>
      </Grid>

      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleClose}
        message="Copied"
        action={
          <React.Fragment>
            <Button color="secondary" size="small" onClick={handleClose}>
              Hide
            </Button>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
      <Footer />
    </div>
  );
};

export default withStyles(styles)(MainPage);
